module.exports = __webpack_public_path__ + "assets/img/zh-Hant-1e1e52b2.png";